import React from 'react';

export const About = () => {
    let photo = {
        width:400 ,
        height: 200,
        resizeMode: 'stretch',

    }
    let container={
        minHeight: "70vh",
        margin: "40px auto",
        color:"white"
    }

    return (

        <div className='container' style={container} >
            <span>
                <img src='logo134.jpeg' style={photo} alt='LOGO COMON'></img>
            </span>
            <span className="ct-span oxy-stock-content-styles">

                <p>What is a todo list and how can it help in business and daily life?</p>



                <p>Do any of the following seem familiar?</p>



                <ul><li>You often feel completely overwhelmed with the amount of work you’ve got to do?</li><li>You sometimes forget to do things that are important</li><li>People have to chase you to get things done</li><li>You find it a struggle to keep to deadlines</li></ul>



                <p>Don’t think you’re unusual because there are thousands of people who struggle with the same every day, not just in the workplace but in their personal life too. Luckily, there is something very simple you can do to keep your life and work more organised.</p>





                <h2>What is a ToDo List?</h2>



                <p>What is a ToDo List? The definition is a simple one. <em><strong>It’s a list of tasks you need to complete or things that you want to do.</strong>&nbsp;</em></p>



                <p>Most typically, they’re organised in order of priority. Traditionally, they’re written on a piece of paper or post it notes and act as a memory aid. As technology has evolved we have been able to create a todo lists with excel spreadsheets, word documents,  lists, todo list apps, Microsoft to do and google to do list to name a few. You can in your home and personal life, or in the workplace.</p>



                <p>Having a list of everything you need to do written down in one place means you shouldn’t forget anything important. By prioritising the tasks in the list you plan the order in which you’re going to do them and can quickly see what needs your immediate attention and what tasks you can leave until a little later.</p>



                <h2>The Benefits of Using a To Do List</h2>



                <p>One of the most important reasons you should use a to do list is that it will help you stay organised. When you write all your tasks in a list, they seem more manageable. When you’ve got a clear outline of the tasks you’ve got to do and those you’ve completed, it helps you stay focused. While freeing up space in your mind for other more creative tasks.</p>



                <p>When you complete a task, you can cross it off your list. This gives you a sense of progress and achievement, something you’ll lack if you’re always rushing from one task to the next. If you feel a sense of achievement, it spurs you on and motivates you to keep moving forward.</p>



                <p>But that’s not the only benefit of a to do list. Here are a few more:</p>



                <p><strong>Improves your memory</strong>: A to do list acts as an external memory aid. It’s only possible to hold a few pieces of information at one time. Keep a to do list and you’ll be able to keep track of everything, rather than just a few of the tasks you need to do. Your to do list will also reinforce the information, which makes it less likely you’re going to forget something.</p>



                <p><strong>Increases productivity</strong>: A to do list allows you to prioritize the tasks that are more important. This means you don’t waste time on tasks that don’t require your immediate attention. Your list will help you stay focused on the tasks that are the most important.</p>



                <p><strong>Helps with motivation</strong>: To do lists are a great motivational tool because you can use them to clarify your goals. You can divide your long-term goal into smaller, more achievable short-term goals and as you tick each one off your list, your confidence will increase.</p>



                <h2>What is a ToDo List in business and why is it important?</h2>



                <p>It seems such a simple solution by putting pen to paper and taking time out of your day to create a to do list, a plan for your day helps define your challenges and goals. Preventing time from being wasted trying to identify what is the next most important task to tackle next and even more important makes sure you don't forget to do something important.</p>



                <p>To-do lists offer a way to increase productivity, stopping you from forgetting things, helps prioritise tasks, manage tasks effectively, use time wisely and improve time management as well as workflow.</p>



                <h2>What Makes a Great To Do List App?</h2>



                <p>To do lists come in all shapes and sizes. It always used to be something that you would write using pen and paper, but thanks to technology there’s an app that can come to the rescue. What makes a good to do list app?</p>



                <ul><li>Tasks should be fast to add and organise</li><li>There should be a variety of ways to organise the tasks</li><li>Ability to plan your workflow</li><li>Setting priorities</li><li>Reminders for any self-imposed deadlines.</li><li>Allocation of tasks if using it for task management with a team. Team to-do list allows you to assign to the best person for the job.</li><li>Able to synch between different platforms</li></ul>



                <p>All it takes is just a few minutes every day to keep a to do list up to date. With a to do list, you can complete goals without wasting time trying to figure out priorities. Your productivity will increase, you won’t forget things, your time management will improve and you’ll be able to manage your tasks more effectively.</p>
            </span>



        </div>

    )
}
